import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import "flatpickr/dist/flatpickr.css"

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static values = { maxDate: String, locale: String }

  connect() {
    this.picker = flatpickr(this.element, {
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "M j, Y",
      allowInput: true,
      maxDate: this.hasMaxDateValue ? this.maxDateValue : null,
      locale: this.localeValue === "es" ? Spanish : "default"
    })
  }

  disconnect() {
    if (this.picker) this.picker.destroy()
  }
}
